import {Component} from "@angular/core";
import {SessionModel} from "../../orchestration/session.model";
import {TranslateService} from "ng2-translate";
import {NavigationService} from "../../orchestration/navigation.service";
import {IdentityModel} from "../identity.model";
import {QrCodePageComponent} from "../../ui-elements/qr-code/qr-code-page/qr-code-page.component";
import {SessionEvents} from "../../orchestration/session-events";

@Component({
    selector: "woa-member-card-panel",
    templateUrl: "./member-card-panel.component.html"
})
export class MemberCardPanelComponent {
    SessionEvents = SessionEvents;

    constructor(public sessionModel: SessionModel,
                public identityModel: IdentityModel,
                private navigationService: NavigationService,
                private translate: TranslateService) {
    }

    async showQrCode(event: MouseEvent): Promise<void> {
        event.stopPropagation();
        if (this.identityModel.currentMember && ((this.identityModel.currentMember.memberCardNo && !this.identityModel.currentMember.integratedLoyaltyId) || this.identityModel.currentMember.integratedCardNo)) {
            return QrCodePageComponent.showQrCode(this.navigationService,
                this.identityModel.currentMember.integratedCardNo || this.identityModel.currentMember.memberCardNo,
                this.translate.instant("woa.label.member.qrCode"));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/identity/member-card-panel/member-card-panel.component.ts